<template>
  <div class="container">
    

  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    created() {
      console.log(this.$route.params)
      
    },
    watch: { },
    mounted() { },
    methods: {
      
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  
</style>



// WEBPACK FOOTER //
// src/components/wxactivity/testactivity/test.vue